import React, { Fragment } from "react";
import {
  ReferenceInput,
  SelectInput,
  TextInput,
  Edit,
  DateInput,
  Button,
  Link,
  Toolbar,
  SaveButton,
  SimpleForm,
  DateField,
  NumberField,
  ReferenceField,
  TextField,
  SimpleShowLayout,
  Show,
  Responsive,
  CardActions,
  Query,
  FunctionField,
  GET_ONE,
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ListBikeHistory from "../components/listBikeHistory";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import styles from "../components/dashboard/Styles";
import { withStyles } from "@material-ui/core/styles";
import dataProviderFactory from "../dataProvider";
import { getPermissionRole } from "../util";

const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right",
};
const cardActionStyle2 = {
  zIndex: 2,
  display: "inline-block",
  width: "100%",
};
const inputStyle = {
  width: "300px",
};

const boxFull = {
  display: "flex",
  flex_wrap: "wrap",
  row_gap: "10px",
  column_gap: "2em",
};

let saleDate = "";
let rentingBike = null;
const VehicleTitle = (object) => {
  rentingBike = object.record.renting;
  return (
    <span>
      {" Sale Bike - "} &quot;{object.record.licence_plate}&quot;{" "}
      {object.record.renting ? "®" : ""}
    </span>
  );
};

const SaleBikeToolbar = (props) => (
  <Toolbar {...props}>
    {([1, 2, 6, 9].includes(getPermissionRole()) && 
    <SaveButton redirect={`/sale_bike/${props.record.id}/show`} />
    )}
    <Button
      component={Link}
      to={{
        pathname: `/current_fleet`,
      }}
      label="Back to Current Fleet"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

const SaleBikeToolbarActions = () => (
  <CardActions style={cardActionStyle}>
    <Button
      component={Link}
      to={{
        pathname: `/current_fleet`,
      }}
      label="Back to Current Fleet"
    >
      <ArrowBackIcon />
    </Button>
  </CardActions>
);

// const validateNIF = nif => {
//   if (
//     !["1", "2", "3", "5", "6", "8"].includes(nif.substr(0, 1)) &&
//     !["45", "70", "71", "72", "77", "79", "90", "91", "98", "99"].includes(
//       nif.substr(0, 2)
//     )
//   )
//     return false;

//   let total =
//     nif[0] * 9 +
//     nif[1] * 8 +
//     nif[2] * 7 +
//     nif[3] * 6 +
//     nif[4] * 5 +
//     nif[5] * 4 +
//     nif[6] * 3 +
//     nif[7] * 2;

//   let modulo11 = total - parseInt(total / 11, 0) * 11;
//   let comparador = modulo11 === 1 || modulo11 === 0 ? 0 : 11 - modulo11;

//   return nif[8] === comparador;
// };

const validateForm = (values) => {
  const errors = {};
  if (!rentingBike) {
    if (!values.sale_date) {
      errors.sale_date = ["Sale date is required"];
    }
    if (!values.sold_to) {
      errors.sold_to = ["Sold to is required"];
    }
    if (!values.sale_price) {
      errors.sale_price = ["Sale price is required"];
    }
    if (!values.name) {
      errors.name = ["Full Name/Company name is required"];
    }
    if (!values.address) {
      errors.address = ["Address is required"];
    }
    if (!values.city) {
      errors.city = ["City is required"];
    }
    if (!values.zip) {
      errors.zip = ["Zip is required"];
    }
    if (!values.province) {
      errors.province = ["Province is required"];
    }
    if (!values.country) {
      errors.country = ["Country is required"];
    }
  }
  // if (values.nif && values.country) {
  //   if (values.country === "Portugal") {
  //     if (!validateNIF(values.nif)) {
  //       errors.nif = ["Nif/Cip is invalid (PT)"];
  //     }
  //   }
  // }

  if (!values.sale_date) {
    errors.sale_date = ["Sale date is required"];
  }
  if (values.sale_date) {
    let retDate = moment(values.retirement_date).format("YYYY-MM-DD");
    let saleDate = moment(values.sale_date).format("YYYY-MM-DD");
    /*  retDate = moment(retDate).add(1, 'days');
     saleDate = moment(saleDate).add(1, 'days'); */
    if (moment(retDate).diff(moment(saleDate), "days") > 0) {
      errors.sale_date = [
        "Sale Date should be later or equal than retirement date",
      ];
    }
  }
  return errors;
};

const payload = {
  pagination: { page: 1, perPage: 1000 },
  filter: { only_sellers: true },
  sort: { field: "country", order: "ASC" },
};

const CountryList = () => (
  <Query type="GET_LIST" resource="countries" payload={payload}>
    {({ data, total, loading, error }) => {
      if (loading) {
        return <p>Loading...</p>;
      }
      if (error) {
        return <p>ERROR</p>;
      }
      return (
        <SelectInput
          source="country"
          optionValue="country"
          optionText="country"
          choices={data}
        />
      );
    }}
  </Query>
);

const SetDate = (param) => {
  this.setState({
    date: moment(Date.parse(param)).format("YYYY-MM-DD"),
  });
};

function SetDateSale() {
  //saleDate = data
  return saleDate;
}

const formatDate = (date) => new Date(date).toISOString().slice(0, 10);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

const GetVehicle = async (id) => {
  const dataProvider = await dataProviderFactory("rest");
  const response = await dataProvider(GET_ONE, "vehicles", { id });
  const bike = response.data;
  rentingBike = bike.renting;
  return response.data;
};

const styleSpan = {
  color: "red",
};

export const SaleVehicleEdit = (props) => {
  const idBike = props.id;
  const location = props.location;
  let rentingBike = null;
  if (location.state != undefined) {
    const estados = location.state;
    rentingBike = estados.renting;
  }
  return (
    <Edit
      title={<VehicleTitle />}
      {...props}
      actions={<SaleBikeToolbarActions />}
    >
      <SimpleForm
        className="boxInitial"
        toolbar={<SaleBikeToolbar props={{ ...props }} />}
        validate={validateForm}
      >
        <FunctionField
          label=" "
          style={cardActionStyle2}
          render={(bike) => {
            saleDate = bike.retirement_date;
            return (
              <ListBikeHistory SetDate={null} vehicleId={bike.id} />
              /*  <a target="_blank" href={bike.express_invoice_url}>
               Invoice (Draft) - {bike.express_invoice_id}{" "}
             </a> */
            );
          }}
        />
        <div className="boxInitial">
          <div className="boxFull">
            <div>
              <DateInput
                label="Tentative Retirement Date"
                style={inputStyle}
                disabled={true}
                locales="es-Es"
                options={{ timeZone: "UTC" }}
                format={Fecha}
                id="retirement_date"
                source="retirement_date"
              />
            </div>
            <div>
              <FunctionField
                render={(bike) => {
                  const d = SetDateSale();
                  bike = d;
                  const labelDate =
                    rentingBike === true
                      ? "Effective Retirement Date"
                      : "Sale Date";
                  return (
                    <DateInput
                      value={d}
                      label={labelDate}
                      id="sale_date"
                      locales="es-Es"
                      options={{ timeZone: "UTC" }}
                      format={Fecha}
                      min={d}
                      style={inputStyle}
                      source="sale_date"
                    />
                  );
                }}
              />
            </div>
            <div>
              {rentingBike === true && (
                <Fragment>
                  <br />
                  <span style={styleSpan}>Bike renting</span>
                </Fragment>
              )}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput
                  label="Sale Price"
                  style={inputStyle}
                  type="number"
                  source="sale_price"
                />
              )}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput label="Zip" style={inputStyle} source="client_zip" />
              )}
            </div>
            <div>
              {rentingBike === false && (
                <ReferenceInput
                  style={inputStyle}
                  label="Sold to"
                  source="sold_to"
                  reference="locations"
                  filter={{ only_sellers: "true" }}
                  sort={{ field: "location_name", order: "ASC" }}
                >
                  <SelectInput
                    source="id"
                    style={inputStyle}
                    optionText="location_name"
                  />
                </ReferenceInput>
              )}{" "}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput
                  label="First Name"
                  style={inputStyle}
                  source="client_first_name"
                />
              )}{" "}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput
                  label="Last Name"
                  style={inputStyle}
                  source="client_last_name"
                />
              )}{" "}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput label="Email" style={inputStyle} source="email" />
              )}{" "}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput
                  label="Address"
                  style={inputStyle}
                  source="client_address"
                />
              )}{" "}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput
                  label="City"
                  style={inputStyle}
                  source="client_city"
                />
              )}{" "}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput label="NIF/CIF" style={inputStyle} source="nif" />
              )}{" "}
            </div>
            <div>
              {rentingBike === false && (
                <TextInput
                  label="Province"
                  style={inputStyle}
                  source="province"
                />
              )}{" "}
            </div>
            <div>{rentingBike === false && <CountryList />}</div>
          </div>
        </div>
      </SimpleForm>
    </Edit>
  );
};

export const SaleVehicleShow = (props) => (
  <Show
    title={<VehicleTitle />}
    actions={<SaleBikeToolbarActions />}
    {...props}
  >
    <SimpleShowLayout>
      <DateField label="Retirement Date" source="retirement_date" />
      <DateField label="Sale Date" source="sale_date" />
      {/* <TextField label="Invoice ID (Draft)" source="express_invoice_id" /> */}
      <FunctionField
        label="Invoice Url (Draft)"
        render={(bike) => {
          return (
            <a target="_blank" href={bike.express_invoice_url}>
              Invoice (Draft) - {bike.express_invoice_id}{" "}
            </a>
          );
        }}
      />

      <FunctionField
        label="Sale Price"
        source="sale_price"
        render={(bike) => {
          return (
            <span>
              {
                (bike.sale_price = new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(bike.sale_price))
              }{" "}
            </span>
          );
        }}
        options={{ style: "currency", currency: "EUR" }}
      />
      <ReferenceField label="Sold to" source="sold_to" reference="locations">
        <TextField source="location_name" />
      </ReferenceField>
    </SimpleShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/resources/saleBike.js